/**
 * AI Response Types Interface
 */

/**
 * AI Generation Types
 */
export enum AIGenerationType {
  DATA_MODEL = 'data-model',
  PAGE = 'page',
  PAGE_LAYOUT = 'page-layout',
  THEME = 'theme',
  ENDPOINT = 'endpoint',
  COMPONENT = 'component',
  ENTITY_COMPONENT = 'entity-component',
  WORKFLOW = 'workflow',
  MESSAGE_TEMPLATE = 'message-template',
  DATA_STORE = 'data-store',
}

/**
 * AI Function IDs
 */
export const aiFunctionIds = {
  DATA_MODEL: '1',
  PAGE: '2',
  PAGE_LAYOUT: '3',
  THEME: '4',
  ENDPOINT: '5',
  COMPONENT: '6',
  ENTITY_COMPONENT: '61',
  WORKFLOW: '7',
  MESSAGE_TEMPLATE: '8',
  DATA_STORE: '9',
} as const;

/**
 * Mapping from function ID to generation type
 */
export const getGenerationType = (functionId: string): AIGenerationType | null => {
  const mapping: Record<string, AIGenerationType> = {
    [aiFunctionIds.DATA_MODEL]: AIGenerationType.DATA_MODEL,
    [aiFunctionIds.PAGE]: AIGenerationType.PAGE,
    [aiFunctionIds.PAGE_LAYOUT]: AIGenerationType.PAGE_LAYOUT,
    [aiFunctionIds.THEME]: AIGenerationType.THEME,
    [aiFunctionIds.ENDPOINT]: AIGenerationType.ENDPOINT,
    [aiFunctionIds.COMPONENT]: AIGenerationType.COMPONENT,
    [aiFunctionIds.ENTITY_COMPONENT]: AIGenerationType.ENTITY_COMPONENT,
    [aiFunctionIds.WORKFLOW]: AIGenerationType.WORKFLOW,
    [aiFunctionIds.MESSAGE_TEMPLATE]: AIGenerationType.MESSAGE_TEMPLATE,
    [aiFunctionIds.DATA_STORE]: AIGenerationType.DATA_STORE,
  };
  return mapping[functionId] || null;
};

/**
 * Interfaces
 */
export interface AIGenerationRequest {
  prompt: string;
  type?: AIGenerationType;
  projectId?: string;
}

export interface AiChatConfig {
  title: string;
  description?: string;
  placeholder?: string;
  buttonText?: string;
  saveButtonText?: string;
  saveButtonIcon?: string;
  type?: AIGenerationType;
  imageUpload?: boolean;
  redirectUrl?: string;
}

export interface AIResponseData {
  id?: string;
  message?: string;
  date?: string;
  channelId?: string;
  projectId?: string;
  projectModelId?: string;
  senderId?: string;
  status?: string;
  responseData?: unknown;
  responseType?: AIGenerationType;
  isEmptyResponse?: boolean;
}

export interface AIResponseStructure {
  name?: string;
  title?: string;
  key?: string;
  subject?: string;
  description?: string;
  type?: string;
  fields?: unknown[];
  exampleData?: unknown[];
  [key: string]: unknown;
}

export interface SplitterEvent {
  sizes: number[];
  [key: string]: unknown;
}
